import React from 'react';
import PropTypes from 'prop-types';
import request from '../../utils/agent';
import CtaPanelRow from 'components/CtaPanelRow';
import UserDataPanel from 'components/UserDataPanel';
import { Redirect, NavLink } from "react-router-dom";
import Loader from 'components/Loader';
import { caStateOpts, usStateOpts } from '../../utils';
import { Formik, Field, FieldArray, Form } from 'formik';
import * as Yup from 'yup';
import './UserHome.scss';

export default class User extends React.Component {
    constructor (props) {
        super(props);

        this.state = {
            userD: { },
            companyD: { },
            couponD: { },
            rDesc: { },
            cData: { },
            userTrainings: { },
            companyId: null,
            compLoaded: false,
            userLoaded: false,
            savingDistData: false,
            isError: false,
            docusign: null,
            dismissed: false,
            geo: null,
            lat: null,
            long: null,
            address_status: "",
            address: '',
            city: '',
            state: '',
            postal: '',
            country: '',
            touched: {
                address: false,
                city: false,
                postal: false,
                country: false,
                state: false,
            }

        }
    }

    componentDidMount(){
        this.getUserData();
        this.getCompanyData();
        this.openNewDistributorModal();
        this.handleLoadDocusignPopup();
        this.openNewResellerModal();
    }

    getUserData = () => {
        return new Promise((resolve, reject) => {
            request.get('/api/user')
                .then(resp => {
                    this.setState({
                        userD: resp.body.user,
                        couponD: resp.body.user.coupons,
                        rDesc: resp.body.user.role,
                        cData: resp.body.user.cdata,
                        userTrainings: resp.body.user.trainings,
                        userLoaded: true,
                    });
                    resolve(resp.body);
                });

        });
    };

    getCompanyData = () => {
        return new Promise((resolve, reject) => {
            request.get('/api/company')
                .then(resp => {
                    this.setState({
                        companyD: resp.body.company,
                        compLoaded: true,
                        address: resp.body.company.address,
                        city: resp.body.company.city,
                        postal: resp.body.company.postal,
                        country: resp.body.company.country,
                        state: resp.body.company.state,
                    });
                    resolve(resp.body);
                });

        });
    };

    getTodaysHours = () => {
        const jsDateToMap = ['Sun', 'Mon', 'Tues', 'Weds', 'Thurs', 'Fri', 'Sat'];
        let today = jsDateToMap[new Date().getDay()];
        if(this.state.companyD.csm && this.state.companyD.csm.hoursofoperation) {
            if(this.state.companyD.csm.hoursofoperation[today]) {
                if(this.state.companyD.csm.hoursofoperation[today].closed) {
                    return 'Closed';
                }
                let open = this.state.companyD.csm.hoursofoperation[today].from + ':00';
                open += parseInt(this.state.companyD.csm.hoursofoperation[today].from) <= 12 ?
                    'am' : 'pm';
                open += ' - ';
                open += this.state.companyD.csm.hoursofoperation[today].to + ':00';
                open += parseInt(this.state.companyD.csm.hoursofoperation[today].to) <= 12 ?
                    'am' : 'pm';
                return open;
            }
        }
        return "";
    };


    openNewDistributorModal = async () => {
        let user;
        try {
            user = await this.getUserData();
            //console.log('user', user);
            let role = user.user.role.name;
            let status = user.user.cdata.onboarding;
            if(role === 'distributor' && status === 'unfinished') {
                this.setState({
                    distUserData: {...this.state.cData},
                    distCompData: {...this.state.companyD},
                }, () => {
                    document.querySelector('body').classList.add('modal-open');
                    this.refs.distributorModal.classList.add('in');
                });
            }

            //console.log('role', role);
        } catch(e) {
            console.log("ERROR: this.getUserData");
            console.log(e);
            return;
        }

       // console.log('user', user);

    };

    closeNewDistributorModal = () => {
        this.refs.distributorModal.classList.remove('in');
        document.querySelector('body').classList.remove('modal-open');
        this.setState({
            distUserData: {...this.defaultDistUser},
            distCompData: {... this.defaultDistComp},
            editingDistData: null,
            savingDistData: false
        });
    };

    openNewResellerModal = async () => {
        let user;
        try {
            user = await this.getUserData();
            //console.log('user', user);
            let role = user.user.role.name;
            let status = user.user.cdata.reseller_agreement_status;
            if(role === 'user' && status === 'unsigned') {
                document.querySelector('body').classList.add('modal-open');
                this.refs.resellerModal.classList.add('in');
            }

            //console.log('role', role);
        } catch(e) {
            console.log("ERROR: this.getUserData");
            console.log(e);
            return;
        }

        // console.log('user', user);

    };

    closeNewResellerModal = () => {
        this.refs.resellerModal.classList.remove('in');
        document.querySelector('body').classList.remove('modal-open');
    };


    createDocusign = (payload) => {
        return new Promise(resolve => {
            request.post('/api/agreement/distributor')
                .send(payload)
                .then(resp => {
                    resolve(resp.body);
                })
                .catch(err => {
                    console.log("ERROR createDocusign");
                    console.log(err);
                    resolve();
                })
        })
    };

    resellerCreateDocusign = (payload) => {
        return new Promise(resolve => {
            request.post('/api/agreement/reseller')
                .send(payload)
                .then(resp => {
                    resolve(resp.body);
                })
                .catch(err => {
                    console.log("ERROR createDocusign");
                    console.log(err);
                    resolve();
                })
        })
    };


    handleLoadDocusignButton = async () => {
        let user;
        try {
            user = await this.getUserData();
        } catch(e) {
            console.log("ERROR: this.getUserData");
            console.log(e);
            return;
        }

        let email= user.user.email;
        let name = `${user.user.cdata.first_name} ${user.user.cdata.last_name}`;
        let userId= user.user.id;
        let company= user.user.company.name;
        let role = user.user.role.name;
        //console.log('role', role);

        this.setState({
            docusignMessage: 'Loading Agreement. Please wait.'
        });
        let payload = {
            email: email,
            name: name,
            userId: userId,
            company: company,
            redirectUrl: `${window.location.origin}/user/agreement`
        };
        //console.log('payload', payload);

        let view;
        if (role === 'user') {
            try {
                view = await this.resellerCreateDocusign(payload);
            } catch(e) {
                console.log("Error creating docusign");
                console.log(e);
                return;
            }
            this.setState({
                docusign: view.url
            });
            window.addEventListener("message", this.docusignListener, false);
        }
        if (role === 'distributor') {
            try {
                view = await this.createDocusign(payload);
            } catch (e) {
                console.log("Error creating docusign");
                console.log(e);
                return;
            }
            this.setState({
                docusign: view.url
            });
            window.addEventListener("message", this.docusignListener, false);
        }
    };

    handleLoadDocusignPopup = async () => {
        let user;
        try {
            user = await this.getUserData();
            let email= user.user.email;
            let name = `${user.user.cdata.first_name} ${user.user.cdata.last_name}`;
            let userId= user.user.id;
            let status = user.user.cdata.agreement_status;
            let role = user.user.role.name;
            let onboarding = user.user.cdata.onboarding;

            if(onboarding === 'completed' &&  status === 'unsigned' && this.state.dismissed === false) {
                this.setState({
                    docusignMessage: 'Loading Agreement. Please wait.'
                });
                let payload = {
                    email: email,
                    name: name,
                    userId: userId,
                    redirectUrl: `${window.location.origin}/user/agreement`
                };
                //console.log('payload', payload);

                let view;
                try {
                    view = await this.createDocusign(payload);
                } catch (e) {
                    console.log("Error creating docusign");
                    console.log(e);
                    return;
                }
                this.setState({
                    docusign: view.url,
                    dismissed: true,
                });
                window.addEventListener("message", this.docusignListener, false);
            }
        } catch(e) {
            console.log("ERROR: this.getUserData");
            console.log(e);
            return;
        }
    };


    docusignListener = (e) => {
        let unsignedMessage = (
                <h2 className='docusign-message'>Sorry, the agreement must be signed before you can access the Noon Pro portal. Please contact a representative to discuss any concerns.
                    <a onClick={this.handleLoadDocusignButton}>Please click here to go back to the agreement</a>
                </h2>
        );

        if (e && e.origin === window.location.origin && e.data) {
            try {
                /**
                 * e.data can be one of these https://developers.docusign.com/esign-rest-api/guides/features/embedding#determining-recipient-action
                 */

                switch(e.data) {
                    case 'signing_complete':
                        request.post(`/api/user/agreement/${this.state.rDesc.name}/${e.data}`)
                            .send({id: this.state.userD.id})
                            .then(resp => {
                                this.setState({
                                    docusignMessage: '',
                                    docusign: null,
                                    role: this.state.rDesc.name,
                                });
                                window.location.reload();
                            });
                        break;
                    default:
                        // Don't allow login on any other item
                        let unsigned = 'unsigned';
                        this.setState({
                            docusignMessage: 'Sorry, the agreement must be signed before you can access the Noon Pro portal. Please contact a representative to discuss any concerns.',
                            docusign: null
                        });
                        request.post(`/api/user/agreement/${this.state.rDesc.name}/${unsigned}`)
                            .send({id: this.state.userD.id})
                            .then(resp => {
                                // No need for response, we just record them not signing agreement
                            });

                }

                window.removeEventListener('message', this.docusignListener);

            } catch (e) {
                console.error(e);
            }
        }
    };

    renderDocusign = () => {
        return (
            <div className="docusign-page">
                <section className="docusign-centered">
                    {this.state.docusign ?
                    <iframe src={this.state.docusign} style={{height: '100vh'}} /> :
                        <div>
                            {this.state.docusignMessage === "Sorry, the agreement must be signed before you can access the Noon Pro portal. Please contact a representative to discuss any concerns." ?
                                <h2 className="docusign-message" style={{marginTop: '5%'}}>{this.state.docusignMessage}
                                    <p className="docusign-message">
                                        <a className='docusign-message-link' onClick={this.handleLoadDocusignButton}> Please click here to go back to the agreement</a>
                                    </p>
                                </h2>:
                                <h2 className="docusign-message" style={{marginTop: '5%'}}>{this.state.docusignMessage}</h2>
                            }

                        </div>
                    }
                </section>
            </div>
        )
    };


    handleDistUserInput = (event) => {
        let distUserData = {...this.state.distUserData};
        let value = event.target.value;
        if(event.target.type === 'checkbox') {
            value = event.target.checked;
        }
        distUserData[event.target.name] = value;
        this.setState({distUserData});
    };

    handleDistCompInput = (event) => {
        let distCompData = {...this.state.distCompData};
        let value = event.target.value;
        if(event.target.type === 'checkbox') {
            value = event.target.checked;
        }
        distCompData[event.target.name] = value;
        this.setState({distCompData});
    };


    getGeocoordinates = (address) => {
        if(!address) {
            address = {
                address: this.state.distCompData.address,
                country: this.state.distCompData.country,
                city: this.state.distCompData.city,
                state: this.state.distCompData.state,
                postal: this.state.distCompData.postal
            }
        }
        return request.post('/api/company/address/coordinates')
            .send({
                address: address
            }).then(resp => {
                return [null, resp.body];
            }).catch(err => {
                return [err];
            })
    };


    handleAdrChange = (e) => {
        e.preventDefault();
        this.setState({
            address: e.target.value,
        })
    };
    handleCountryChange = (e) => {
        e.preventDefault();
        this.setState({
            country: e.target.value,
        })
    };
    handleCityChange = (e) => {
        e.preventDefault();
        this.setState({
            city: e.target.value,
        })
    };
    handleStateChange = (e) => {
        e.preventDefault();
        this.setState({
            state: e.target.value,
        })
    };
    handlePostalChange = (e) => {
        e.preventDefault();
        this.setState({
            postal: e.target.value,
        })
    };

    handleAdrBlur = (fieldName) => (e) => {
        this.setState({
            touched: {
                ...this.state.touched, [fieldName]: true
            },
        })
    };

    validateAdr(address, city, state, postal, country){
        return {
            address: address.length === 0,
            city: city.length === 0,
            state: state.length === 0,
            postal: postal.length === 0,
            country: country.length === 0,
        };
    };

    handleSubmitErr(e) {
        e.preventDefault();
        this.setState({
            touched: {
                address: true,
                city: true,
                postal: true,
                country: true,
                state: true,
            }
        })
    };

    handleVerifyAddress = async(address, city, state, postal, country) => {
        //evt.preventDefault();
        let geoloc = await request.post(`/api/company/address/coordinates`)
            .send ({"address": {"address": address, "country": country, "city": city, "state": state, "postal": postal}
            })
            .then(resp => {
                //console.log('response',resp.body.geospatial);
                return resp.body;
            })
            .catch(err => {
                console.log(err);
            });

        //console.log('geoloc', geoloc);
        if (geoloc !== undefined) {
            this.setState({
                geo: geoloc.geospatial,
                lat: geoloc.latitude,
                long: geoloc.longitude,
                address_status: "valid",
            })
        }

    };

    newResellerModal = () => {
        return (
            <div id="resellerModal" ref="resellerModal" className="modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="reseller-modal-body">
                            <h4 className="modal-title"><span id="resellerModal"></span>reseller agreement must be signed before you can access the Noon Pro portal. Please contact a representative to discuss any concerns.</h4>
                            <a className='reseller-modal-btn' onClick={this.handleLoadDocusignButton}>Sign Agreement</a>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    newDistributorModal = () => {

        const errors = this.validateAdr(this.state.address, this.state.city, this.state.state, this.state.state, this.state.country);
        //console.log('errors', errors);

        const isDisabled = Object.keys(errors).some(x => errors[x]);
        //console.log('isDisabled', isDisabled);

        //console.log('touched', this.state.touched);

        const shouldShowError = (fieldName) => {
            const hasErr = errors[fieldName];
            const shouldShow = this.state.touched[fieldName];
            return hasErr ? shouldShow : false;
        };


        const caStates = caStateOpts ;
        const usStates = usStateOpts;

        const countryOpts = [
            {id: '', display: 'Select Country'},
            {id: 'US', display: 'USA'},
            {id: 'CA', display: 'Canada'},
        ];

        const phoneRegExp = /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,3}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/;

        const ProfileSchema = Yup.object().shape({
            email: Yup.string().email('This value should be a valid email.').required('This value is required.'),
            first_name: Yup.string().required('This value is required.'),
            last_name: Yup.string().required('This value is required.'),
            name: Yup.string().required('This value is required.'),
            dba: Yup.string().required('This value is required.'),
            primary_jobtitle: Yup.string().required('This value is required.'),
            phone: Yup.string().matches(phoneRegExp, 'Phone number should be valid').required('This value is required.'),
            //country: Yup.string().required('This value is required.'),
            //address: Yup.string().required('This value is required.'),
            //city: Yup.string().required('This value is required.'),
            // state: Yup.string().required('This value is required.'),
            // postal: Yup.string().required('This value is required.').matches(/^[a-zA-Z0-9]*$/, 'This value should be alphanumeric characters only'),
            domain: Yup.string().required('This value is required.').url('This value should be a valid url.'),
            established: Yup.string().required('This value is required.'),
            sales_name: Yup.string().required('This value is required.'),
            sales_phone: Yup.string().matches(phoneRegExp, 'Phone number should be valid').required('This value is required.'),
            sales_email: Yup.string().email('This value should be a valid email.').required('This value is required.'),
            accounts_name: Yup.string().required('This value is required.'),
            accounts_phone: Yup.string().matches(phoneRegExp, 'Phone number should be valid').required('This value is required.'),
            accounts_email: Yup.string().email('This value should be a valid email.').required('This value is required.'),
            logistics_name: Yup.string().required('This value is required.'),
            logistics_phone: Yup.string().matches(phoneRegExp, 'Phone number should be valid').required('This value is required.'),
            logistics_email: Yup.string().email('This value should be a valid email.').required('This value is required.'),
            bank_phone: Yup.string().matches(phoneRegExp, 'Phone number should be valid'),
            bank_email: Yup.string().email('This value should be a valid email.'),
            first_creditref_phone: Yup.string().matches(phoneRegExp, 'Phone number should be valid'),
            first_creditref_email: Yup.string().email('This value should be a valid email.'),
            second_creditref_phone: Yup.string().matches(phoneRegExp, 'Phone number should be valid'),
            second_creditref_email: Yup.string().email('This value should be a valid email.'),
        });



        return (
            <div id="distributorModal" ref="distributorModal" className="modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title"><span id="distributorModal"></span>Noon Home Customer Onboarding Form</h4>
                        </div>
                        <div className="modal-body">
                            <Formik

                                initialValues={{
                                    email: this.state.userD.email,
                                    first_name: this.state.cData.first_name,
                                    last_name: this.state.cData.last_name,
                                    name: this.state.companyD.name,
                                    dba: this.state.companyD.dba,
                                    primary_jobtitle: this.state.companyD.primary_jobtitle,
                                    phone: this.state.companyD.phone,
                                    address: this.state.companyD.address,
                                    country: this.state.companyD.country,
                                    city: this.state.companyD.city,
                                    state: this.state.companyD.state,
                                    postal: this.state.companyD.postal,
                                    domain: this.state.companyD.domain,

                                    subsidiary_name: "",
                                    mailing_address: "",
                                    mailing_city: "",
                                    mailing_state: "",
                                    mailing_postal: "",
                                    mailing_country: "",
                                    established: "",
                                    duns: "",
                                    sales_name: "",
                                    sales_phone: "",
                                    sales_email: "",
                                    accounts_name: "",
                                    accounts_phone: "",
                                    accounts_email: "",
                                    logistics_name: "",
                                    logistics_phone: "",
                                    logistics_email: "",
                                    bank_name: "",
                                    bank_address: "",
                                    bank_representative: "",
                                    bank_phone: "",
                                    bank_email: "",
                                    first_creditref_name: "",
                                    first_creditref_address: "",
                                    first_creditref_representative: "",
                                    first_creditref_phone: "",
                                    first_creditref_email: "",
                                    second_creditref_name: "",
                                    second_creditref_address: "",
                                    second_creditref_representative: "",
                                    second_creditref_phone: "",
                                    second_creditref_email: "",

                                }}
                                enableReinitialize={true}
                                validationSchema={ProfileSchema}
                                onSubmit={ async (values, actions) => {

                                    this.setState({savingDistData: true});

                                    let data =  await this.handleVerifyAddress(this.state.address, this.state.city, this.state.state, this.state.postal, this.state.country,);

                                    let user;
                                    try {
                                        user = await this.getUserData();
                                    } catch(e) {
                                        console.log("ERROR: this.getUserData");
                                        console.log(e);
                                        return;
                                    }

                                    let email= user.user.email;
                                    let name = `${user.user.cdata.first_name} ${user.user.cdata.last_name}`;
                                    let userId= user.user.id;

                                    const onboarding = 'completed';

                                    return Promise.all([
                                        request.post(`/api/updatedist/${onboarding}`)
                                            .send({
                                                email: values.email,
                                                first_name: values.first_name,
                                                last_name: values.last_name,
                                                subsidiary_name: values.subsidiary_name,
                                                mailing_address: values.mailing_address,
                                                mailing_city: values.mailing_city,
                                                mailing_state: values.mailing_state,
                                                mailing_postal: values.mailing_postal,
                                                mailing_country: values.mailing_country,
                                                established: values.established,
                                                duns: values.duns,
                                                sales_name: values.sales_name,
                                                sales_phone: values.sales_phone,
                                                sales_email: values.sales_email,
                                                accounts_name: values.accounts_name,
                                                accounts_phone: values.accounts_phone,
                                                accounts_email: values.accounts_email,
                                                logistics_name: values.logistics_name,
                                                logistics_phone: values.logistics_phone,
                                                logistics_email: values.logistics_email,
                                                bank_name: values.bank_name,
                                                bank_address: values.bank_address,
                                                bank_representative: values.bank_representative,
                                                bank_phone: values.bank_phone,
                                                bank_email: values.bank_email,
                                                first_creditref_name: values.first_creditref_name,
                                                first_creditref_address: values.first_creditref_address,
                                                first_creditref_representative: values.first_creditref_representative,
                                                first_creditref_phone: values.first_creditref_phone,
                                                first_creditref_email: values.first_creditref_email,
                                                second_creditref_name: values.second_creditref_name,
                                                second_creditref_address: values.second_creditref_address,
                                                second_creditref_representative: values.second_creditref_representative,
                                                second_creditref_phone: values.second_creditref_phone,
                                                second_creditref_email: values.second_creditref_email,
                                            }),
                                        request.post('/api/company')
                                            .send({
                                                name: values.name,
                                                dba: values.dba,
                                                primary_jobtitle: values.primary_jobtitle,
                                                phone: values.phone,
                                                domain: values.domain,

                                                country: this.state.country,
                                                address: this.state.address,
                                                city: this.state.city,
                                                state: this.state.state,
                                                postal: this.state.postal,
                                                address_status: this.state.address_status,
                                                latitude: this.state.lat,
                                                longitude: this.state.long,
                                                geospatial: this.state.geo,

                                                reseller_certification: this.state.companyD.reseller_certification,
                                                dealer_finder: this.state.companyD.dealer_finder,
                                                business_type: this.state.companyD.business_type,

                                                speciality: null,
                                                business_coverage: null,
                                                coverage_range: null,
                                                years_in_business: null,
                                                number_of_employees: null,
                                                number_of_stores: null,
                                                primary_distributor: null,
                                                secondary_distributor: null,
                                                document_uuid: null,
                                                electrician_certification: null,
                                                coverage_segments: null,
                                                services_offered: null,
                                                experience_with_noon: null,
                                                provide_staff_training: null,

                                            })
                                    ])
                                        .then(data => {
                                            //console.log('finished user call');
                                            //console.log(data);
                                        })
                                        .then(async(resp) => {
                                            this.setState({
                                                geo: null,
                                                lat: null,
                                                long: null,
                                                address_status:'',
                                                docusignMessage: 'Loading Agreement. Please wait.'
                                            });
                                            let payload = {
                                                email: email,
                                                name: name,
                                                userId: userId,
                                                redirectUrl: `${window.location.origin}/user/agreement`
                                            };
                                            //console.log('payload', payload);

                                            let view;
                                            try {
                                                view = await this.createDocusign(payload);
                                            } catch(e) {
                                                console.log("Error creating docusign");
                                                console.log(e);
                                                return;
                                            }
                                            this.setState({
                                                docusign: view.url
                                            });
                                            window.addEventListener("message", this.docusignListener, false);
                                        })
                                        .catch(err => {
                                            console.error(err);
                                            this.setState({isError: true});
                                        });

                                }}>
                                {({
                                      values,
                                      errors,
                                      touched,
                                      handleChange,
                                      handleBlur,
                                      handleSubmit,
                                      isSubmitting,
                                      setFieldValue,
                                      handleReset,
                                      dirty,
                                      isValid,
                                      isValidating,

                                  }) => (
                                    <Form className='my-f-form' onSubmit={e => {
                                        handleSubmit(e);
                                        if(isDisabled === true) {
                                            this.handleSubmitErr(e)
                                        }
                                    }}>
                                        <p className='description-text'>Please complete your NOON partner profile below.
                                            This information will be used for sales, logistics, billing and other related activities.
                                            Credit references and bank information must be provided if you wish to receive payment terms.
                                            If you have any questions regarding this form please reach out to
                                            <a href='mailto:customer-onboarding@noonhome.com'> customer-onboarding@noonhome.com</a>.</p>

                                        <label className='form-f-label'>Company Legal Name*</label>
                                        <Field
                                            name='name'
                                            component='input'
                                            className={errors.name && touched.name ? 'form-f-field with-error' : 'form-f-field'}
                                            type='text'
                                            placeholder='Company Name*'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.name}
                                        />
                                        {errors.name && touched.name ?
                                            (<div className='f-field-errors'>{errors.name}</div>) : null
                                        }

                                        <label className='form-f-label'>Company Trade Name / DBA</label>
                                        <Field
                                            name='dba'
                                            component='input'
                                            className={errors.dba && touched.dba ? 'form-f-field with-error' : 'form-f-field'}
                                            type='text'
                                            placeholder='Doing Business As*'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.dba}
                                        />
                                        {errors.dba && touched.dba ?
                                            (<div className='f-field-errors'>{errors.dba}</div>) : null
                                        }

                                        <label className='form-f-label'>If Subsidiary, Name of Parent Company</label>
                                        <Field
                                            name='subsidiary_name'
                                            component='input'
                                            className='form-f-field'
                                            type='text'
                                            placeholder='Subsidiary Name'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.subsidiary_name}
                                        />

                                        <label className='form-f-label'>Company Phone Number*</label>
                                        <Field
                                            name='phone'
                                            component='input'
                                            className={errors.phone && touched.phone ? 'form-f-field with-error' : 'form-f-field'}
                                            type='text'
                                            placeholder='(___)___-____'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.phone}
                                        />
                                        {errors.phone && touched.phone ?
                                            (<div className='f-field-errors'>{errors.phone}</div>) : null
                                        }

                                        <h4 className='profile-data-sub-section'>Company Billing Address</h4>

                                        <label className='form-f-label'>Country*</label>
                                        <select
                                            name='country'
                                            className='single-choice-selector'
                                            value={this.state.country}
                                            onChange={e => this.handleCountryChange(e)}
                                            onBlur={this.handleAdrBlur('country')}
                                        >
                                            {countryOpts.map(option => (
                                                <option key={`country-${option.id}`} value={option.id}>
                                                    {option.display}
                                                </option>
                                            ))}
                                        </select>
                                        {shouldShowError('country') ?
                                            (<div className='f-field-errors'>This value is required.</div>) : null
                                        }

                                        <label className='form-f-label'>Address*</label>
                                        <input
                                            name='address'
                                            className={shouldShowError('address') ? 'form-f-field with-error' : 'form-f-field'}
                                            type='text'
                                            placeholder='Address*'
                                            value={this.state.address}
                                            onChange={e => this.handleAdrChange(e)}
                                            onBlur={this.handleAdrBlur('address')}
                                        />
                                        {shouldShowError('address') ?
                                            (<div className='f-field-errors'>This value is required.</div>) : null
                                        }

                                        <div className='flex--fields--holder'>
                                            <div className='flex-field-container'>
                                                <label className='form-f-label'>City*</label>
                                                <input
                                                    name='city'
                                                    className={shouldShowError('city') ? 'form-f-field with-error' : 'form-f-field'}
                                                    type='text'
                                                    placeholder='City*'
                                                    value={this.state.city}
                                                    onChange={e => this.handleCityChange(e)}
                                                    onBlur={this.handleAdrBlur('city')}
                                                />
                                                {shouldShowError('city') ?
                                                    (<div className='f-field-errors'>This value is required.</div>) : null
                                                }
                                            </div>

                                            {this.state.country === 'CA' ?
                                                <div className='flex-field-container'>
                                                    <label className='flex-form-label'>State*</label>
                                                    <select
                                                        name='state'
                                                        className='state-selector'
                                                        placeholder='State'
                                                        value={this.state.state}
                                                        onChange={e => this.handleStateChange(e)}
                                                        onBlur={this.handleAdrBlur('state')}
                                                    >
                                                        {caStates.map(option => (
                                                            <option key={`state-${option.id}`}
                                                                    value={option.id}>
                                                                {option.display}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {shouldShowError('state') ?
                                                        (<div className='f-field-errors'>This value is required.</div>) : null
                                                    }
                                                </div>:
                                                <div className='flex-field-container'>
                                                    <label className='flex-form-label'>State*</label>
                                                    <select
                                                        name='state'
                                                        className='state-selector'
                                                        placeholder='State'
                                                        value={this.state.state}
                                                        onChange={e => this.handleStateChange(e)}
                                                        onBlur={this.handleAdrBlur('state')}
                                                    >
                                                        {usStates.map(option => (
                                                            <option key={`state-${option.id}`}
                                                                    value={option.id}>
                                                                {option.display}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {shouldShowError('state') ?
                                                        (<div className='f-field-errors'>This value is required.</div>) : null
                                                    }
                                                </div>
                                            }

                                            <div className='flex-field-container last'>
                                                <label className='form-f-label'>Postal Code*</label>
                                                <input
                                                    name='postal'
                                                    className={shouldShowError('postal') ? 'form-f-field with-error' : 'form-f-field'}
                                                    type='text'
                                                    placeholder='Postal Code*'
                                                    value={this.state.postal}
                                                    onChange={e => this.handlePostalChange(e)}
                                                    onBlur={this.handleAdrBlur('postal')}
                                                />
                                                {shouldShowError('postal') ?
                                                    (<div className='f-field-errors'>This value is required.</div>) : null
                                                }
                                            </div>
                                        </div>




                                        <h4 className='profile-data-sub-section'>Company Mailing Address (if different from Billing Address above)</h4>

                                        <label className='form-f-label'>Country</label>
                                        <select
                                            name='mailing_country'
                                            className='single-choice-selector'
                                            value={values.mailing_country}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        >
                                            {countryOpts.map(option => (
                                                <option key={`mailing_country-${option.id}`} value={option.id}>
                                                    {option.display}
                                                </option>
                                            ))}
                                        </select>

                                        <label className='form-f-label'>Address</label>
                                        <input
                                            name='mailing_address'
                                            className='form-f-field'
                                            type='text'
                                            placeholder='Address'
                                            value={values.mailing_address}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />

                                        <div className='flex--fields--holder'>
                                            <div className='flex-field-container'>
                                                <label className='form-f-label'>City</label>
                                                <input
                                                    name='mailing_city'
                                                    className='form-f-field'
                                                    type='text'
                                                    placeholder='City'
                                                    value={values.mailing_city}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                />

                                            </div>

                                            {this.state.country === 'CA' ?
                                                <div className='flex-field-container'>
                                                    <label className='flex-form-label'>State</label>
                                                    <select
                                                        name='mailing_state'
                                                        className='state-selector'
                                                        placeholder='State'
                                                        value={values.mailing_state}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                    >
                                                        {caStates.map(option => (
                                                            <option key={`mailing_state-${option.id}`}
                                                                    value={option.id}>
                                                                {option.display}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>:
                                                <div className='flex-field-container'>
                                                    <label className='flex-form-label'>State</label>
                                                    <select
                                                        name='mailing_state'
                                                        className='state-selector'
                                                        placeholder='State'
                                                        value={values.mailing_state}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                    >
                                                        {usStates.map(option => (
                                                            <option key={`mailing_state-${option.id}`}
                                                                    value={option.id}>
                                                                {option.display}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            }

                                            <div className='flex-field-container last'>
                                                <label className='form-f-label'>Postal Code</label>
                                                <input
                                                    name='mailing_postal'
                                                    className='form-f-field'
                                                    type='text'
                                                    placeholder='Postal Code'
                                                    value={values.mailing_postal}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                />
                                            </div>
                                        </div>

                                        <label className='form-f-label'>Website*</label>
                                        <Field
                                            name='domain'
                                            component='input'
                                            className={errors.domain && touched.domain ? 'form-f-field with-error' : 'form-f-field'}
                                            type='text'
                                            placeholder='Website*'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.domain}
                                        />
                                        {errors.domain && touched.domain ?
                                            (<div className='f-field-errors'>{errors.domain}</div>) : null
                                        }

                                        <label className='form-f-label'>Year Established*</label>
                                        <Field
                                            name='established'
                                            component='input'
                                            className={errors.established && touched.established ? 'form-f-field with-error' : 'form-f-field'}
                                            type='text'
                                            placeholder='Year Established'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.established}
                                        />
                                        {errors.established && touched.established ?
                                            (<div className='f-field-errors'>{errors.established}</div>) : null
                                        }

                                        <label className='form-f-label'>D&B/DUNS Number</label>
                                        <Field
                                            name='duns'
                                            component='input'
                                            className='form-f-field'
                                            type='text'
                                            placeholder='D&B/DUNS Number'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.duns}
                                        />
                                        
                                        <h3 className='profile-data-section'>Contact Information</h3>

                                        <p>Please provide appropriate contact information for the departments listed below.
                                            This will ensure we are communicating with the appropriate members of your business. </p>

                                        <h5 className='profile-data-sub-section'>Sales</h5>

                                        <label className='form-f-label'>Name*</label>
                                        <Field
                                            name='sales_name'
                                            className={errors.sales_name && touched.sales_name ? 'form-f-field with-error' : 'form-f-field'}
                                            component='input'
                                            type='text'
                                            placeholder='Name*'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.sales_name}/>
                                        {errors.sales_name && touched.sales_name ?
                                            (<div className='f-field-errors'>{errors.sales_name} </div>) : null
                                        }

                                        <label className='form-f-label'>Phone*</label>
                                        <Field
                                            name='sales_phone'
                                            className={errors.sales_phone && touched.sales_phone ? 'form-f-field with-error' : 'form-f-field'}
                                            component='input'
                                            type='text'
                                            placeholder='(___)___-____'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.sales_phone}/>
                                        {errors.sales_phone && touched.sales_phone ?
                                            (<div className='f-field-errors'>{errors.sales_phone} </div>) : null
                                        }

                                        <label className='form-f-label'>Email*</label>
                                        <Field
                                            name='sales_email'
                                            className={errors.sales_email && touched.sales_email ? 'form-f-field with-error' : 'form-f-field'}
                                            component='input'
                                            type='text'
                                            placeholder='Email*'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.sales_email}/>
                                        {errors.sales_email && touched.sales_email ?
                                            (<div className='f-field-errors'>{errors.sales_email} </div>) : null
                                        }

                                        <h5 className='profile-data-sub-section'>Accounts Payable</h5>

                                        <label className='form-f-label'>Name*</label>
                                        <Field
                                            name='accounts_name'
                                            className={errors.accounts_name && touched.accounts_name ? 'form-f-field with-error' : 'form-f-field'}
                                            component='input'
                                            type='text'
                                            placeholder='Name*'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.accounts_name}/>
                                        {errors.accounts_name && touched.accounts_name ?
                                            (<div className='f-field-errors'>{errors.accounts_name} </div>) : null
                                        }

                                        <label className='form-f-label'>Phone*</label>
                                        <Field
                                            name='accounts_phone'
                                            className={errors.accounts_phone && touched.accounts_phone ? 'form-f-field with-error' : 'form-f-field'}
                                            component='input'
                                            type='text'
                                            placeholder='(___)___-____'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.accounts_phone}/>
                                        {errors.accounts_phone && touched.accounts_phone ?
                                            (<div className='f-field-errors'>{errors.accounts_phone} </div>) : null
                                        }

                                        <label className='form-f-label'>Email*</label>
                                        <Field
                                            name='accounts_email'
                                            className={errors.accounts_email && touched.accounts_email ? 'form-f-field with-error' : 'form-f-field'}
                                            component='input'
                                            type='text'
                                            placeholder='Email*'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.accounts_email}/>
                                        {errors.accounts_email && touched.accounts_email ?
                                            (<div className='f-field-errors'>{errors.accounts_email} </div>) : null
                                        }

                                        <h5 className='profile-data-sub-section'>Shipping & Logistics</h5>

                                        <label className='form-f-label'>Name*</label>
                                        <Field
                                            name='logistics_name'
                                            className={errors.logistics_name && touched.logistics_name ? 'form-f-field with-error' : 'form-f-field'}
                                            component='input'
                                            type='text'
                                            placeholder='Name*'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.logistics_name}/>
                                        {errors.logistics_name && touched.logistics_name ?
                                            (<div className='f-field-errors'>{errors.logistics_name} </div>) : null
                                        }

                                        <label className='form-f-label'>Phone*</label>
                                        <Field
                                            name='logistics_phone'
                                            className={errors.logistics_phone && touched.logistics_phone ? 'form-f-field with-error' : 'form-f-field'}
                                            component='input'
                                            type='text'
                                            placeholder='(___)___-____'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.logistics_phone}/>
                                        {errors.logistics_phone && touched.logistics_phone ?
                                            (<div className='f-field-errors'>{errors.logistics_phone} </div>) : null
                                        }

                                        <label className='form-f-label'>Email*</label>
                                        <Field
                                            name='logistics_email'
                                            className={errors.logistics_email && touched.logistics_email ? 'form-f-field with-error' : 'form-f-field'}
                                            component='input'
                                            type='text'
                                            placeholder='Email*'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.logistics_email}/>
                                        {errors.logistics_email && touched.logistics_email ?
                                            (<div className='f-field-errors'>{errors.logistics_email} </div>) : null
                                        }

                                        <h3 className='profile-data-section'>Bank & Credit References</h3>

                                        <p >If you would like credit terms to be extended to your business please provide your bank and credit reference(s) for credit review by NOON.
                                            If no credit needs to be extended (i.e., paying by credit card) please leave blank.</p>

                                        <h5 className='profile-data-sub-section'>Bank Reference</h5>

                                        <label className='form-f-label'>Bank Name</label>
                                        <Field
                                            name='bank_name'
                                            className='form-f-field'
                                            component='input'
                                            type='text'
                                            placeholder='Bank Name'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.bank_name}/>


                                        <label className='form-f-label'>Bank Address</label>
                                        <Field
                                            name='bank_address'
                                            className='form-f-field'
                                            component='input'
                                            type='text'
                                            placeholder='Bank Address'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.bank_address}/>

                                        <label className='form-f-label'>Bank Contact Representative</label>
                                        <Field
                                            name='bank_representative'
                                            className='form-f-field'
                                            component='input'
                                            type='text'
                                            placeholder='Bank Contact Representative'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.bank_representative}/>
                                        <label className='form-f-label'>Bank Contact Phone Number</label>
                                        <Field
                                            name='bank_phone'
                                            className={errors.bank_phone && touched.bank_phone ? 'form-f-field with-error' : 'form-f-field'}
                                            component='input'
                                            type='text'
                                            placeholder='(___)___-____'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.bank_phone}/>
                                        {errors.bank_phone && touched.bank_phone ?
                                            (<div className='f-field-errors'>{errors.bank_phone} </div>) : null
                                        }

                                        <label className='form-f-label'>Bank Contact Email</label>
                                        <Field
                                            name='bank_email'
                                            className={errors.bank_email && touched.bank_email ? 'form-f-field with-error' : 'form-f-field'}
                                            component='input'
                                            type='text'
                                            placeholder='Bank Contact Email'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.bank_email}/>
                                        {errors.bank_email && touched.bank_email ?
                                            (<div className='f-field-errors'>{errors.bank_email} </div>) : null
                                        }

                                        <h5 className='profile-data-sub-section'>Credit Reference #1</h5>

                                        <label className='form-f-label'>Company Name</label>
                                        <Field
                                            name='first_creditref_name'
                                            className='form-f-field'
                                            component='input'
                                            type='text'
                                            placeholder='Company Name'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.first_creditref_name}/>


                                        <label className='form-f-label'>Company Address</label>
                                        <Field
                                            name='first_creditref_address'
                                            className='form-f-field'
                                            component='input'
                                            type='text'
                                            placeholder='Company Address'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.first_creditref_address}/>

                                        <label className='form-f-label'>Company Contact Representative</label>

                                        <Field
                                            name='first_creditref_representative'
                                            className='form-f-field'
                                            component='input'
                                            type='text'
                                            placeholder='Company Contact Representative'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.first_creditref_representative}/>

                                        <label className='form-f-label'>Company Contact Phone Number</label>
                                        <Field
                                            name='first_creditref_phone'
                                            className={errors.first_creditref_phone && touched.first_creditref_phone ? 'form-f-field with-error' : 'form-f-field'}
                                            component='input'
                                            type='text'
                                            placeholder='(___)___-____'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.first_creditref_phone}/>
                                        {errors.first_creditref_phone && touched.first_creditref_phone ?
                                            (<div className='f-field-errors'>{errors.first_creditref_phone} </div>) : null
                                        }

                                        <label className='form-f-label'>Company Contact Email</label>
                                        <Field
                                            name='first_creditref_email'
                                            className={errors.first_creditref_email && touched.first_creditref_email ? 'form-f-field with-error' : 'form-f-field'}
                                            component='input'
                                            type='text'
                                            placeholder='Company Contact Email'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.first_creditref_email}/>
                                        {errors.first_creditref_email && touched.first_creditref_email ?
                                            (<div className='f-field-errors'>{errors.first_creditref_email} </div>) : null
                                        }


                                        <h5 className='profile-data-sub-section'>Credit Reference #2</h5>

                                        <label className='form-f-label'>Company Name</label>
                                        <Field
                                            name='second_creditref_name'
                                            className='form-f-field'
                                            component='input'
                                            type='text'
                                            placeholder='Company Name'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.second_creditref_name}/>


                                        <label className='form-f-label'>Company Address</label>
                                        <Field
                                            name='second_creditref_address'
                                            className='form-f-field'
                                            component='input'
                                            type='text'
                                            placeholder='Company Address'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.second_creditref_address}/>

                                        <label className='form-f-label'>Company Contact Representative</label>

                                        <Field
                                            name='second_creditref_representative'
                                            className='form-f-field'
                                            component='input'
                                            type='text'
                                            placeholder='Company Contact Representative'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.second_creditref_representative}/>

                                        <label className='form-f-label'>Company Contact Phone Number</label>
                                        <Field
                                            name='second_creditref_phone'
                                            className={errors.second_creditref_phone && touched.second_creditref_phone ? 'form-f-field with-error' : 'form-f-field'}
                                            component='input'
                                            type='text'
                                            placeholder='(___)___-____'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.second_creditref_phone}/>
                                        {errors.second_creditref_phone && touched.second_creditref_phone ?
                                            (<div className='f-field-errors'>{errors.second_creditref_phone} </div>) : null
                                        }

                                        <label className='form-f-label'>Company Contact Email</label>
                                        <Field
                                            name='second_creditref_email'
                                            className={errors.second_creditref_email && touched.second_creditref_email ? 'form-f-field with-error' : 'form-f-field'}
                                            component='input'
                                            type='text'
                                            placeholder='Company Contact Email'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.second_creditref_email}/>
                                        {errors.second_creditref_email && touched.second_creditref_email ?
                                            (<div className='f-field-errors'>{errors.second_creditref_email} </div>) : null
                                        }

                                        <h3 className='m-section-subtitle'>Signature</h3>
                                        <p>By submitting this form, you authorize Noon Home, Inc. to make inquiries into the banking and business credit references provided. Furthermore, the undersigned acknowledges that Noon Home, Inc. will store the information provided in an electronic format:
                                            I hereby certify that the information provided on this form, together with all other information submitted in connection with this application is true and correct. I understand that Noon Home, Inc. will rely on this information for the purposes of extending relevant credit and contractual terms to my company and I authorize Noon Home,
                                            Inc. to contact and obtain information from the references provided.
                                        </p>

                                        <div className='flex--fields--holder'>
                                            <div className='flex-field-container'>
                                                <label className='form-f-label'>First Name*</label>
                                                <div className='flex-with-error-holder'>
                                                    <Field
                                                        name='first_name'
                                                        component='input'
                                                        className={errors.first_name && touched.first_name ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                        type='text'
                                                        placeholder='First Name*'
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.first_name}
                                                    />
                                                    {errors.first_name && touched.first_name ? (
                                                        <div
                                                            className='f-field-errors'>{errors.first_name}</div>) : null
                                                    }
                                                </div>
                                            </div>

                                            <div className='flex-field-container last'>
                                                <label className='form-f-label'>Last Name*</label>
                                                <div className='flex-with-error-holder'>
                                                    <Field
                                                        name='last_name'
                                                        component='input'
                                                        className={errors.last_name && touched.last_name ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                        type='text'
                                                        placeholder='Last Name*'
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.last_name}
                                                    />
                                                    {errors.last_name && touched.last_name ?
                                                        (<div
                                                            className='f-field-errors'>{errors.last_name}</div>) : null
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        <label className='form-f-label'>Job Title*</label>
                                        <Field
                                            name='primary_jobtitle'
                                            component='input'
                                            className={errors.primary_jobtitle && touched.primary_jobtitle ? 'form-f-field with-error' : 'form-f-field'}
                                            type='text'
                                            placeholder='Job Title*'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.primary_jobtitle}
                                        />
                                        {errors.primary_jobtitle && touched.primary_jobtitle ?
                                            (<div className='f-field-errors'>{errors.primary_jobtitle}</div>) : null
                                        }

                                        <div className='error-box-cont'>
                                            {this.state.isError === true ?
                                                <p className='submission-error-text'>Ooops something went wrong!
                                                    Please try again later</p> :
                                                null
                                            }
                                        </div>
                                        <button type='submit' className='form-f-button'>{this.state.savingDistData ? 'Submitting...' : 'Submit'}</button>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        )
    }


    render() {

        if(this.state.docusignMessage) {
            return this.renderDocusign();
        }

        //console.log("userD", this.state.userD);
        //console.log("companyD", this.state.companyD);
        //console.log("cdata", this.state.rDesc);
        //console.log("cdata", this.state.cData);
        //console.log('user', this.state.userD);


        let code = (
            <div> </div>
        );

        let shopifyFlag = false;
        if(this.state.couponD.length > 0) {
            code = (
                <ul className='coupons--container'>
                    {this.state.couponD.map((item, index) => (
                        <li className='coupon--text' key={index}>{item.code}</li>
                    ))}
                </ul>
            );
            shopifyFlag = true;
        }

        let trainingFlag = false;

        let trainingRes = "";
        if (this.state.userTrainings.length > 0) {
            const latestTraining = this.state.userTrainings.length-1;
            //console.log('last tr', latestTraining);
            if(this.state.userTrainings[latestTraining].percent >= 80) {
                trainingRes = "PASSED";
                trainingFlag = true;
            }
            if(this.state.userTrainings[latestTraining].percent > 0 && this.state.userTrainings[latestTraining].percent < 80 ) {
                trainingRes = "FAILED";
                trainingFlag = false;
            }
        }
        if(this.state.userTrainings.length === 0) {
            trainingRes = "NOT TAKEN";
        }



        const panelsContent = [
            {
                icon:'ion-ios-book-outline',
                ctaLabel:'training',
                ctaRoute:'/user/training',
                myClasses: 'user--dash',
            },
            {
                icon:'ion-ios-gear-outline',
                ctaLabel:'support',
                ctaRoute:'/user/support',
                myClasses: 'user--dash',
            }
        ];

        const panelsHidden = [
            {
                icon:'ion-ios-book-outline',
                ctaLabel:'training',
                ctaRoute:'/user/training',
                myClasses: 'user--dash',
            },
        ];

        //let user = this.state.userD.role.name;
        //console.log('userD', this.state.userD );

        //let reseller = user === 'user';
        //let distributor = user === 'distributor';


        return(
            <div>
                {this.state.userLoaded === false ?
                    <Loader/> :
                    <div>
                        {this.state.userD.role.name === 'user' &&
                        <section className='user--dashboard--container'>
                            <h1>Home</h1>
                            <div className='details-section'>
                                <UserDataPanel role={this.state.rDesc.name} companyData={this.state.companyD}
                                               email={this.state.userD.email} tStatus={trainingRes}
                                               showCoupon={shopifyFlag}
                                               couponCode={code} roleDesc={this.state.rDesc.desc}
                                               cdata={this.state.cData}/>
                            </div>
                            {this.state.userD.company && this.state.userD.company.csm &&
                            <div className="details-section">
                                <div className="user--info--container">
                                    <div className="user-info-col">
                                        <h5 className="table-title">CUSTOMER SERVICE MANAGER</h5>
                                        <table className="user-info-table csm">
                                            <tbody>
                                            <tr>
                                                <td><p className="user-title">Name</p></td>
                                                <td><p
                                                    className="user-content">{this.state.userD.company.csm.first_name} {this.state.userD.company.csm.last_name}</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><p className="user-title">Email</p></td>
                                                <td><p
                                                    className="user-content">{this.state.userD.company.csm.email}</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><p className="user-title">Phone</p></td>
                                                <td><p
                                                    className="user-content">{this.state.userD.company.csm.phone}</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><p className="user-title">Today's Hours</p></td>
                                                <td><p className="user-content">{this.getTodaysHours()}</p></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>}
                            <div className='support-info-container'>
                                <h4>Need help?</h4>
                                <p>Get in touch with NOON Support.</p>
                                <p>Call us at 1 833-232-2347 or email <a className='support--link'
                                                                         href="mailto:support@noonhome.com">support@noonhome.com</a>.
                                </p>
                                <p>We're available 5 days a week.</p>
                                <p>7:00 AM to 4:00 PM PT Monday to Friday</p>
                            </div>

                            <h1>Welcome to NOON Pro</h1>
                            <p>Here you can access training material, FAQs, marketing materials and support
                                portal
                                to help
                                with any queries you might have.</p>

                            {trainingFlag === false ?
                                <div>
                                    <p className='bold-note-text'>Once you have passed the NOON training quiz
                                        you
                                        will gain
                                        access to all Pro benefits.</p>
                                    <div className='hidden-panels-cont'>
                                        <CtaPanelRow ctaPanels={panelsHidden}/>
                                    </div>
                                </div> :
                                <div>
                                    <CtaPanelRow ctaPanels={panelsContent}/>
                                </div>
                            }
                            {this.newResellerModal()};
                        </section>
                        }


                        {this.state.userD.role.name !== 'user' &&
                        <div>
                            {this.state.cData.onboarding === 'completed' && this.state.cData.agreement_status === 'unsigned' ?
                                <section className='user--dashboard--container'>
                                    <h1>Home</h1>
                                    <div className='details-section'>
                                        <UserDataPanel role={this.state.rDesc.name} companyData={this.state.companyD}
                                                       email={this.state.userD.email} tStatus={trainingRes}
                                                       showCoupon={shopifyFlag}
                                                       couponCode={code} roleDesc={this.state.rDesc.desc}
                                                       cdata={this.state.cData}/>
                                    </div>
                                    {this.state.userD.company && this.state.userD.company.csm &&
                                    <div className="details-section">
                                        <div className="user--info--container">
                                            <div className="user-info-col">
                                                <h5 className="table-title">CUSTOMER SERVICE MANAGER</h5>
                                                <table className="user-info-table csm">
                                                    <tbody>
                                                    <tr>
                                                        <td><p className="user-title">Name</p></td>
                                                        <td><p
                                                            className="user-content">{this.state.userD.company.csm.first_name} {this.state.userD.company.csm.last_name}</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td><p className="user-title">Email</p></td>
                                                        <td><p
                                                            className="user-content">{this.state.userD.company.csm.email}</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td><p className="user-title">Phone</p></td>
                                                        <td><p
                                                            className="user-content">{this.state.userD.company.csm.phone}</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td><p className="user-title">Today's Hours</p></td>
                                                        <td><p className="user-content">{this.getTodaysHours()}</p></td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>}
                                    <div className='support-info-container'>
                                        <h4>Need help?</h4>
                                        <p>Get in touch with NOON Support.</p>
                                        <p>Call us at 1 833-232-2347 or email <a className='support--link'
                                                                                 href="mailto:support@noonhome.com">support@noonhome.com</a>.
                                        </p>
                                        <p>We're available 5 days a week.</p>
                                        <p>7:00 AM to 4:00 PM PT Monday to Friday</p>
                                    </div>

                                    <h1>Welcome to NOON Pro</h1>
                                    <p>Here you can access training material, FAQs, marketing materials and support
                                        portal
                                        to help
                                        with any queries you might have.</p>

                                    {trainingFlag === false ?
                                        <div>
                                            <p className='bold-note-text'>Once you have passed the NOON training quiz
                                                you
                                                will gain
                                                access to all Pro benefits.</p>
                                            <div className='hidden-panels-cont'>
                                                <CtaPanelRow ctaPanels={panelsHidden}/>
                                            </div>
                                        </div> :
                                        <div>
                                            <CtaPanelRow ctaPanels={panelsContent}/>
                                        </div>
                                    }
                                    <section>
                                        <button
                                            onClick={this.handleLoadDocusignButton}
                                            className="btn btn-default btn-primary btn-view-users"> NOON Agreement
                                        </button>
                                    </section>

                                    {this.newDistributorModal()}
                                </section> :
                                <section className='user--dashboard--container'>
                                    <h1>Home</h1>
                                    <div className='details-section'>
                                        <UserDataPanel role={this.state.rDesc.name} companyData={this.state.companyD}
                                                       email={this.state.userD.email} tStatus={trainingRes}
                                                       showCoupon={shopifyFlag}
                                                       couponCode={code} roleDesc={this.state.rDesc.desc}
                                                       cdata={this.state.cData}/>
                                    </div>
                                    {this.state.userD.company && this.state.userD.company.csm &&
                                    <div className="details-section">
                                        <div className="user--info--container">
                                            <div className="user-info-col">
                                                <h5 className="table-title">CUSTOMER SERVICE MANAGER</h5>
                                                <table className="user-info-table csm">
                                                    <tbody>
                                                    <tr>
                                                        <td><p className="user-title">Name</p></td>
                                                        <td><p
                                                            className="user-content">{this.state.userD.company.csm.first_name} {this.state.userD.company.csm.last_name}</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td><p className="user-title">Email</p></td>
                                                        <td><p
                                                            className="user-content">{this.state.userD.company.csm.email}</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td><p className="user-title">Phone</p></td>
                                                        <td><p
                                                            className="user-content">{this.state.userD.company.csm.phone}</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td><p className="user-title">Today's Hours</p></td>
                                                        <td><p className="user-content">{this.getTodaysHours()}</p></td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>}
                                    <div className='support-info-container'>
                                        <h4>Need help?</h4>
                                        <p>Get in touch with NOON Support.</p>
                                        <p>Call us at 1 833-232-2347 or email <a className='support--link'
                                                                                 href="mailto:support@noonhome.com">support@noonhome.com</a>.
                                        </p>
                                        <p>We're available 5 days a week.</p>
                                        <p>7:00 AM to 4:00 PM PT Monday to Friday</p>
                                    </div>

                                    <h1>Welcome to NOON Pro</h1>
                                    <p>Here you can access training material, FAQs, marketing materials and support
                                        portal
                                        to help
                                        with any queries you might have.</p>

                                    {trainingFlag === false ?
                                        <div>
                                            <p className='bold-note-text'>Once you have passed the NOON training quiz
                                                you
                                                will gain
                                                access to all Pro benefits.</p>
                                            <div className='hidden-panels-cont'>
                                                <CtaPanelRow ctaPanels={panelsHidden}/>
                                            </div>
                                        </div> :
                                        <div>
                                            <CtaPanelRow ctaPanels={panelsContent}/>
                                        </div>
                                    }
                                    {this.newDistributorModal()}
                                </section>
                            }
                        </div>
                        }
                    </div>
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/routes/User/index.js